import React from "react";

import * as UI from "./ui";

const generatePromoSummary = count => {
  return count > 0 ? ` + ${count} Promo Code Entries` : "";
};

const EntryNumbers = ({ receipt }) => {
  return (
    <React.Fragment>
      <UI.EntrySummary>
        {receipt.rewardTicketCount} Entries
        {generatePromoSummary(receipt.promoCodeTicketCount)}
      </UI.EntrySummary>
      <UI.EntryNumbers>
        <ul>
          { receipt.ticketRanges.map(({ min, max }) => (
            <li key={min}>Entry #{ min } - #{ max }</li>
          )) }
        </ul>
      </UI.EntryNumbers>
    </React.Fragment>
  );
};

export default EntryNumbers;
